import styled from 'styled-components'
import { TouchableOpacity } from 'react-native'
import { colors } from 'infra/color'
import { RowLayout } from 'ui/common/layout'

export const BottomButton = styled(TouchableOpacity)`
  background-color: ${(p) => (!p.disabled ? colors.primary : colors.gray.v400)};
  border-radius: 999px;
  padding: 14px 24px;
`

export const BottomButtonContainer = styled(RowLayout).attrs({
  pointerEvents: 'box-none',
})`
  position: absolute;
  width: 100%;
  justify-content: center;
  align-items: center;
`
